var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExistingItems',{attrs:{"items":_vm.items,"title":"Υφιστάμενα Συμπτώματα"},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('router-link',{attrs:{"to":{
        name: 'products.symptoms.edit',
        params: { uuid: props.item.uuid },
      }}},[_vm._v(" "+_vm._s(props.item.title)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }